<template>
  <div class="investor-footer">
    <v-container fluid>
      <v-row>
        <v-col cols="12" offset-md="1" md="4">
          <p>
            This virtual deal room is updated regularly with curated trade and investment opportunities between the U.S.
            and Africa. Please check back frequently to review the newest deals.
          </p>
        </v-col>
        <v-col cols="12" md="4">
          <p>You can also find information about <a href="https://www.prosperafrica.gov/services/" target="_blank">U.S.
              Government services and resources</a> that can support successful private sector transactions.</p>
        </v-col>
        <v-col class="shrink d-flex" cols="12" md="2">
          <a href="https://www.prosperafrica.gov/about/" class="learn-more" target="_blank">
            <span class="mr-2">Learn more about</span>
            <span>Prosper Africa →</span>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'investor-footer'
}
</script>

<style lang="scss" scoped>
.investor-footer {
  background: #f0f0f0;
  backdrop-filter: blur(20px);
  opacity: 0.98;
  font-size: 18px;
  line-height: 150%;
  padding-top: 30px;

  a {
    color: #002f6c;
  }
}
.learn-more {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-decoration: none;
  color: #002f6c;
  span {
    white-space: nowrap;
  }
}
</style>
